import {values} from 'lodash';
import {ReportPackStatus} from '../../schema-types/globalTypes';

export interface ReportPackDashboardValues {
  search?: string;
  adviserIds: string[];
  statuses: ReportPackStatus[];
}

// when it first loads, show all statuses (no filters applied)
export const reportPackDashboardPageDefaultStatuses: ReportPackStatus[] = [];

export const reportPackDashboardPageInitialValues: ReportPackDashboardValues = {
  search: undefined,
  adviserIds: [],
  statuses: reportPackDashboardPageDefaultStatuses,
};

export const reportPackStatusKeys = values(ReportPackStatus);
